import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useLocation, useHistory } from "react-router-dom";
import { state } from '../state';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useTheme } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from "@material-ui/core/IconButton";

import { useSnapshot } from 'valtio';
import axios from 'axios';

import {
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';

import logo from './../logo.png';

const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  root: {
    flexGrow: 1,
    color: 'white',
  },
  logo: {
    maxWidth: 120,
    flexGrow: 1,
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 85,
    },
  },

  icon: {
    fill: 'white',
},
  select: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down('sm')]: {
      width: '12rem',
    },
    [theme.breakpoints.down('xs')]: {
      width: '8rem',
    },
    [theme.breakpoints.down(365)]: {
      width: '5rem',
    },
     color: 'white',
    '&:before': {
        borderColor: 'white',
    },
    '&:after': {
        borderColor: 'white',
    },
    '&:not(.Mui-disabled):hover::before': {
        borderColor: 'white',
    },
},
  logoBox: {
    pointerEvents: 'none',
  },
  domainBox: {
    flexGrow: 1,
  },
  appBar: {
      background: "#1863e6",
      position: "fixed",
  }
}));


export default function AppHeader() {
  const classes = useStyles();
  const location = useLocation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));


  var showLogout = true;
  if (location.pathname === "/login" || location.pathname === "/signup" || location.pathname === "/checkout_success"
   || location.pathname === "/reset_password" || location.pathname === "/confirm_email" || location.pathname === "/forgot_password" || location.pathname === "/report") {
    showLogout = false;
  }

  const GetData = async () => {  
    const result = await axios.get('/api/shield/list')
    .then(function (response) {
      if (response.data === null){
        state.domains = ["none"];
        state.currentDomain = "none";
        return
      } 
      state.domains = response.data;
      if (response.data.length !== 0 && state.currentDomain === ""){
        state.currentDomain = response.data[0];
      }
    });
  }

  React.useEffect(() => { 
    if (showLogout) {
    GetData();
    }
  }, []);   

  const handleSelect = (event) => {
    state.currentDomain = event.target.value;
  }

  const history = useHistory();
  function logout(){
    localStorage.removeItem("token");
    localStorage.removeItem("expires");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("role");
    if (!location.pathname.includes("login")){
      localStorage.setItem("lastlink", location.pathname);
    }
    history.push('login');
  }

  function addsite(){
    history.push('new_website');
  }

  const snap = useSnapshot(state);

  return (
    <React.Fragment>
    <div className={classes.root}>
      <AppBar className={classes.appBar}>
        <Toolbar>
        <Box className={classes.logoBox}>
            <img src={logo} alt="logo" className={classes.logo} />
        </Box>
        { showLogout && snap.domains.length > 0 ? (
        <Box className={classes.domainBox} paddingLeft={3}>
            <FormControl>
          
          <Select
           className={classes.select}
            labelId="domain-selector"
            id="domain-selector"
            variant="standard"
            autoWidth
            inputProps={{
              classes: {
                  icon: classes.icon,
                  root: classes.root,
              },
            }}
            value={snap.currentDomain}
            onChange={handleSelect}
          >
            {snap.domains.map((domain) => {
             return <MenuItem value={domain}>{domain}</MenuItem>
            })}
          </Select>        
        </FormControl>
        </Box>
        )
        : null
        }
        { showLogout ? (
        <Box>
        {matches ? (
          <Box>
        <IconButton color="inherit" onClick={addsite}>
        <AddCircleIcon/>
        </IconButton>
        <IconButton color="inherit" onClick={logout}>
        <ExitToAppIcon/>
        </IconButton>
        </Box>
        ) : (
          <Box>
        <Button color="inherit" startIcon={<AddCircleIcon/>} onClick={addsite}>New Site</Button> 
         <Button color="inherit" startIcon={<ExitToAppIcon/>} onClick={logout}>Log Out</Button> 
         </Box>
        )
        }
        </Box>
        )
        : null
        }
        </Toolbar>
      </AppBar>
      <div className={classes.toolbar} />
    </div>
  </React.Fragment>
  );
}